import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAngularModule } from '../../shared/modules/mat-angular.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmUpdateProjectDialogData {
  title: string;
  description: string;
}

@Component({
  selector: 'app-common-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatAngularModule],
  templateUrl: './common-confirm-dialog.component.html',
  styleUrl: './common-confirm-dialog.component.scss'
})
export class CommonConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CommonConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmUpdateProjectDialogData
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
